export enum CUSTOM_EVENTS {
    CART_API_FETCHED = "CART_API_FETCHED",
    CART_API_ERROR = "CART_API_ERROR",
    FETCH_API_ERROR = "FETCH_API_ERROR",
}
